// Generate a filename with current date and time
export const generateFilename = (label = 'file', extension = 'xlsx') => {
  const now = new Date();
  const dateStr = now.toISOString().split('T')[0].replace(/-/g, ''); // Format: YYYYMMDD
  return `${dateStr} Export ${label}.${extension}`;
};

// Trigger a download for a Blob
export const downloadBlob = (blob, filename) => {
  const downloadURL = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = downloadURL;
  link.download = filename;
  link.click();
  // Clean up by revoking the object URL to release memory
  window.URL.revokeObjectURL(downloadURL);
};

// Create and download an Excel file Blob from binary data
export const downloadExcelFile = (binaryData, label = 'export') => {
  const filename = generateFilename(label, 'xlsx');
  const blob = new Blob([binaryData], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  downloadBlob(blob, filename);
};

export const downloadZipFile = (binaryData, label = 'export') => {
  const filename = generateFilename(label, 'zip');
  const blob = new Blob([binaryData], {
    type: "application/zip",
  });
  downloadBlob(blob, filename);
};